export const locale = {
    lang: 'en',
    data: {
        'HOME': {
            'HELLO': 'Welcome at the intranet of Divardy'
        },
        
    }
};
